import { Crest } from '@/components/shared/Crest';

interface Props {
  memberName: string;
  holeNum: number;
  courseName: string;
  onShare: () => void;
  onSavor: () => void;
}

const CONFETTI = ['🦅', '⛳', '🏆', '🎯', '✨', '🥃', '🍾'];

export function HoleInOneCelebration({ memberName, holeNum, courseName, onShare, onSavor }: Props) {
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center overflow-hidden bg-[radial-gradient(ellipse_at_center,#0a1e3f_0%,#050d1f_100%)] p-5">
      {CONFETTI.map((emoji, i) => (
        <div
          key={i}
          className="ace-float pointer-events-none absolute"
          style={{
            left: `${10 + (i * 13) % 80}%`,
            bottom: -50,
            fontSize: 24 + (i % 3) * 6,
            animationDuration: `${3 + (i % 4)}s`,
            animationDelay: `${i * 0.3}s`,
          }}
        >
          {emoji}
        </div>
      ))}

      <div className="ace-spin pointer-events-none absolute opacity-[0.12]">
        <Crest size={320} variant="dark" />
      </div>

      <div className="ace-pop relative z-10 w-full max-w-sm rounded-[20px] border border-gold/30 bg-white/[0.04] p-8 text-center text-cream backdrop-blur-sm">
        <div className="ace-shimmer inline-block rounded-full bg-gold px-3 py-1 text-[10px] font-extrabold tracking-[0.2em] text-navy">
          ACE · +500 POINTS
        </div>
        <div className="mt-4 font-serif text-[42px] font-extrabold leading-tight tracking-tight text-gold">
          HOLE IN ONE.
        </div>
        <div className="mt-2 text-sm text-white/85">{memberName}</div>
        <div className="mt-1 text-sm text-white/70">
          Hole {holeNum} · {courseName}
        </div>
        <div className="mt-8 flex flex-col gap-2">
          <button type="button" onClick={onShare} className="rounded-xl bg-gold py-3.5 text-sm font-extrabold tracking-wide text-navy">
            🦅 Tell the Clubhouse
          </button>
          <button type="button" onClick={onSavor} className="rounded-xl border border-white/20 py-3 text-xs font-semibold text-white/75">
            Just savor it
          </button>
        </div>
      </div>
    </div>
  );
}
